import React,{Component} from 'react';

import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Filters from './components/Filters';
import UsersCountTable from './components/UsersCountTable';

import API from '../../services/API';

class UsersCount extends Component {
    constructor() {
        super();

        this.state = {
            countries: [],
            filters: {},
            counters: [],
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.loadCountries();
        this.loadCounters();
    }

    componentDidUpdate(nextProps,prevState) {
        if(this.state.filters !== prevState.filters) {
            this.loadCounters() ;
        }
    }

    loadCountries() {
        API.Users.getCountries().then(countries => {
            this.setState({countries});
        })
    }

    loadCounters() {
        this.setState({
            isLoading: true
        });

        API.Users.count(this.state.filters).then(counters => {
            this.setState({
                counters,
                isLoading: false
            });
        })
    }

    handleSubmit(filters) {
        console.log(filters);
        this.setState({filters});
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Users Count"/>
                <Filters
                    countries={this.state.countries}
                    onSubmit={this.handleSubmit}
                />
                <UsersCountTable
                    counters={this.state.counters}
                />
            </Container>
        );
    }
}

export default UsersCount;


// WEBPACK FOOTER //
// ./src/scenes/UsersCount/index.js